<template>
  <div>
      <v-toolbar dense
                 src="https://www.arcgis.com/sharing/rest/content/items/8f762395cd204552bb958ecb1b54339d/resources/1588745514029.jpeg?w=2932"
      >
        <v-spacer></v-spacer>
      </v-toolbar>
    <v-container class="container--fluid">
      <v-icon @click="cancelForm" class="float-right">mdi-close</v-icon>
      <h1 class="text-center">{{diet.name}} - {{diet.dietType}}</h1>
      <v-row
        justify="center"
        no-gutters
       >
        <v-col id="edit-dietgroups-tables   col-sm-12 col-md-6 col-xl-6">
          <v-data-table
            style=""
            :headers="headers"
            :items="dietItems[index]"
            :single-expand="singleExpand"
            :expanded="expanded"
            items-per-page="100"
            item-key="name"
            show-expand
            class="elevation-1 order-table"
            hide-default-footer
            disable-sort
            dense
            calculate-widths
            v-for="(time, index) in dietItems"
            :key="index"
          >
            <template v-slot:top>
              <v-toolbar flat dense>
                <v-toolbar-title>{{timeTypes.length ? timeTypes[index].name : ''}}</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>
            </template>
            <template v-slot:item.delete="{ item }">
              <v-icon
                v-if="currentUser.roleId === 1 || currentUser.roleId === 2"
                color="error"
                @click="deleteItem(item)"
              >mdi-delete-forever</v-icon>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td
                :colspan="headers.length"
                v-if="item.type === 'App\\Menu'"
              >
                <div
                  v-for="(menuItem, index) in item.drinks.concat(item.foods)" :key="index"
                >{{menuItem.name}}</div>
              </td>
              <td
                :colspan="headers.length"
                v-else
              >{{item.name}}</td>
            </template>
          </v-data-table>
        </v-col>
        <v-col class="col-sm-12 col-md-6 col-xl-6 ">
          <AddToDietForm
            :diet-day-id="dietDayId"
            :diet="diet"
            id="edit-dietgroups-form"
            @date-change="getDietDay"
          ></AddToDietForm>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import AddToDietForm from '../../components/forms/admin/AddToDietForm'
import { mapGetters } from 'vuex'
export default {
  name: 'AddToDiet',
  components: { AddToDietForm },
  props: ['diet'],
  data () {
    return {
      date: null,
      dietDayId: null,
      singleExpand: true,
      expanded: [],
      headers: [
        {
          text: 'Název',
          align: 'start',
          sortable: false,
          value: 'name',
          width: 300
        },
        { text: 'Alergeny', value: 'alergensStr' },
        { text: 'Kalorie', value: 'calories' },
        { text: 'Cena', value: 'price' },
        { text: 'Priorita', value: 'menuSequence' },
        { text: '', value: 'data-table-expand' },
        { text: '', value: 'delete' }
      ],
      dietItems: [[], [], [], [], [], []],
      availableAlergens: [],
      availableFoodTypes: [],
      timeTypes: [],
      allFoods: [],
      allDrinks: [],
      allMenus: []
    }
  },
  methods: {
    cancelForm () {
      this.$emit('formCanceled')
    },
    initialize () {
      this.$http.get('/admin/times')
        .then(response => { this.timeTypes = this.keysToCamelCase(response.data) })
        .catch(err => console.log(err))
    },
    deleteItem (item) {
      if (confirm(`Opravdu chcete odstranit položku s názvem ${item.name}?`)) {
        this.$http.delete(`/admin/diets/${this.diet.id}/days/${this.dietDayId}/items/${item.id}`)
          .then(res => {
            this.getDietDay(this.date)
          })
      }
    },
    getDietDay (date) {
      this.date = date
      this.$http.get(`/admin/diets/${this.diet.id}/days/date/${date}`)
        .then(response => {
          this.dietItems = [[], [], [], [], [], []]
          let dietDayItems = []
          const res = this.keysToCamelCase(response.data)
          if (Object.keys(res).length) {
            dietDayItems = res.dietDayItems
          }
          const items = dietDayItems.map(item => {
            item = { ...item.eatable, ...item }
            item.alergensStr = item.alergens
              .map(alergen => alergen.name)
              .join(', ')
            return item
          })

          this.allDrinks = items.filter(item => item.type === 'App\\Drink')
          this.allFoods = items.filter(item => item.type === 'App\\Food')
          this.allMenus = items.filter(item => item.type === 'App\\Menu')
          this.dietItems = this.dietItems.map((time, index) => {
            return items.filter(item => item.timeId === index + 1)
          })
          this.dietDayId = response.data.id
        })
        .catch(err => {
          console.log(err)
        })
    },
    extractUniqueById (array) {
      const sorted = array.sort((a, b) => a.id - b.id)
      const result = []; let prevId

      for (let i = 0; i < sorted.length; i++) {
        if (sorted[i].id !== prevId) {
          result.push(sorted[i])
        }
        prevId = sorted[i].id
      }
      return result
    }
  },
  created () {
    this.initialize()
  },
  computed: {
    ...mapGetters({ currentUser: 'user/currentUser' })
  }
}
</script>

<style scoped>
.v-data-table{
  margin-top: 10px;
}
  #edit-dietgroups-tables{
    max-width: 850px;
    margin: auto;
  }
  #edit-dietgroups-form{
    max-width: 750px;
  }
</style>
